
import { defineComponent, PropType } from "vue";
import { IKeHoachSuaChuaResponseBase } from "@/core/interfaces/ApiResponses";
import { useRouterCustom } from "@/core/hooks/use-router-custom";
import { usePagination } from "@/core/hooks/use-pagination";
import WordBreakColumn from "@/components/shared/work-break-column/WordBreakColumn.vue";
import Setting from "@/components/shared/setting/Setting.vue";
import type { SettingAction } from "@/components/shared/setting/Setting.vue";
import IconEye from "@/icons/IconEye.vue";
import IconPencil from "@/icons/IconPencil.vue";
import IconTrash from "@/icons/IconTrash.vue";
import BaseLink from "@/components/shared/base-link/BaseLink.vue";
import { mapMutations } from "vuex";
import { useLoading } from "@/core/hooks/use-loading";
import { KeHoachSuaChuaService } from "@/core/services/KeHoachSuaChua.service";
import { swalErrNotification, swalNotification } from "@/core/helpers/utils";

export default defineComponent({
  name: "ke-hoach-table",

  components: { BaseLink, Setting, WordBreakColumn },

  setup() {
    const { push } = useRouterCustom();
    const { indexCal } = usePagination();
    const { startLoading, endLoading } = useLoading();

    return { endLoading, indexCal, push, startLoading };
  },

  props: {
    curPage: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array as PropType<Array<IKeHoachSuaChuaResponseBase>>,
    },
    perPage: {
      type: Number,
      default: 0,
    },
  },

  methods: {
    ...mapMutations("ConfirmationDialogModule", {
      setDialog: "setDialog",
      closeDialog: "closeDialog",
    }),

    onDeleteButtonClick(row: IKeHoachSuaChuaResponseBase) {
      this.setDialog({
        message: `Bạn có chắc chắn muốn xoá kế hoạch sửa chữa ${row.ten_ke_hoach}?`,
        onConfirm: async () => {
          this.closeDialog();
          await this.startLoading();

          try {
            await KeHoachSuaChuaService.delete(row.id);
            await this.endLoading();
            await swalNotification("Xoá kế hoạch sửa chữa thành công");

            this.$router.replace({
              name: "danh-sach-ke-hoach-sua-chua",
            });
          } catch (e) {
            await this.endLoading();
            await swalErrNotification(e, "Không thể xoá kế hoạch sửa chữa này");
          }
        },
      });
    },

    getSettingActions(row: IKeHoachSuaChuaResponseBase): SettingAction[] {
      return [
        {
          icon: IconEye,
          label: "Chi tiết",
          tooltip: "Chi tiết kế hoạch",
          onClick: () =>
            this.push(`/quan-ly/ke-hoach-sua-chua/chi-tiet/${row.id}`),
        },
        {
          icon: IconPencil,
          label: "Chỉnh sửa",
          tooltip: "Chỉnh sửa kế hoạch",
          any: ["data:kehoachsuachua:sua"],
          onClick: () =>
            this.push(`/quan-ly/ke-hoach-sua-chua/chinh-sua/${row.id}`),
        },
        {
          icon: IconTrash,
          label: "Xoá",
          tooltip: "Xoá kế hoạch",
          any: ["data:kehoachsuachua:xoa"],
          onClick: () => this.onDeleteButtonClick(row),
        },
      ];
    },
  },
});
